module.exports = __webpack_public_path__ + "static/media/patrick-tomasso.9ab45f3d.jpg";